import React, { useEffect } from 'react'
import { Alert, BodyText, CaptionText } from '@paypalcorp/pp-react'
import { trackPage } from 'ppbl/utils/fpti-helper'
import { merge } from 'lodash-es'
import clientLogger from 'ppbl/utils/client-logger'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import {
  approvalChancesPercentage,
  PARTNER_CAMP_ID,
  UTM_CAMPAIGN,
} from 'ppbl/utils/constants'
import { interpolate } from 'ppbl/utils/string-helper'
import serverData from 'ppbl/utils/server-data'
import './index.css'

interface PreQualifiedBannerProps {
  applicationType: string
  applicationId: string
}

const PreQualifiedBanner: React.FC<PreQualifiedBannerProps> = ({
  applicationType,
  applicationId,
}) => {
  useEffect(() => {
    const campID =
      localStorage.getItem(PARTNER_CAMP_ID) ||
      sessionStorage.getItem(UTM_CAMPAIGN) ||
      serverData?.startParams?.utm_campaign
    const fptiData = {
      page: `preQualifiedBanner::${campID}`,
    }
    trackPage(
      merge(fptiData, {
        applicationId,
      }),
    )
    clientLogger.info(
      'Prequalified banner displayed - campaign, applicationType:',
      {
        campaignId: campID,
        applicationType,
      },
    )
  }, [])

  return (
    <div className="preQualifiedBannerWrapper">
      <Alert className="preQualifiedBanner">
        <BodyText strong>
          {getLocalizedText('components.preQualifiedBanner.banner')}
        </BodyText>
      </Alert>
      <CaptionText>
        <em>
          {interpolate(
            getLocalizedText('components.preQualifiedBanner.bodyText'),
            {
              approvalChancesPercentage,
            },
          )}
        </em>{' '}
      </CaptionText>
    </div>
  )
}

export default PreQualifiedBanner
